<template>
    <!-- banner section  -->
    <!-- banner section  -->
    <section class="container">
        <div class="page-header mt-4">
            <div class="overly"></div>

            <div class="row justify-content-center align-items-center">
                <div class="col-lg-12">
                    <div class="content">
                        <h1 class="mb-3 text-white">{{tempProductArray.productName}}</h1>
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb bg-transparent justify-content-center">
                                <li class="breadcrumb-item"><a type="button" @click="redirecttohomepage">Home</a></li>
                                <li class="breadcrumb-item active" aria-current="page" type="button" @click="redirecttoProductList">Shop</li>
                                <li class="breadcrumb-item active" aria-current="page">{{tempProductArray.productName}}</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </section>


    <section class="single-product pd-80">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <div class="single-product-slider">
                        <div id="sync1" class="owl-carousel owl-theme">

                            <div class="item">

                                <img :src="tempProductArray.imageUrl" class="img-fluid" alt="weaver-blend" />
                            </div>

                        </div>


                    </div>
                </div>

                <div class="col-md-6">
                    <div class="single-product-details mt-lg-0">
                        <h2>{{tempProductArray.productName}}</h2>
                        <h3 class="product-price" v-if="tempProductArray.price == tempProductArray.salePrice">
                            ${{productSalesPrice}}
                        </h3>

                        <h3 class="product-price" v-else>
                            <del>${{productPrice}}</del> ${{productSalesPrice}}
                        </h3>


                        <hr>
                        <div class="small-product-description my-4 ">
                            <ul class="">
                                <div :title="[tempProductArray.productDescription.replace( /(<([^>]+)>)/ig, '')]" v-if="$filters.IsNull(tempProductArray.productDescription,true,null)!=null">
                                    <span class="answer-inline" v-html="$filters.TruncateStr(tempProductArray.productDescription,50)"></span>
                                    <a v-if="tempProductArray.productDescription != null && tempProductArray.productDescription.length>50"
                                       @click="OpenDescriptionModel(tempProductArray)" href="javascript:;">
                                        <i class="fa fa-eye" aria-hidden="true"></i>

                                    </a>
                                    <!--<span v-else href="javascript:;">
                                {{ description.data.description}}
                            </span>-->
                                </div>
                                <!--<p v-html="tempProductArray.productDescription"></p>-->
                            </ul>
                            <ul class="list-inline mb-0">
                                <li v-if="tempProductArray.isShip== true">
                                    <i class="fa-solid fa-truck"></i> Nationwide shipping on select orders.
                                </li>
                                <li v-else>
                                    <i class="fa-solid fa-truck"></i>This product is available for Local delivery.
                                </li>
                                <!--<li>
        <i class="fa-solid fa-calendar-days"></i> Delivers in 3-7 working days
    </li>-->

                            </ul>
                            <!--<ul>
                    <p v-html="tempProductArray.productDescription"></p>
                    <span v-if="limitedDescription.length > 150"> <button type="button"  id="nav-home-tab" data-bs-target="#nav-home" data-bs-toggle="tab" class="active" >Read More...</button> </span>
                    </ul>-->

                        </div>

                        <form class="cart" action="#" method="post">
                            <div class="quantity d-flex align-items-center">
                                <div v-if="showHideQuantityDiv">
                                    <p class="qty" v-if="tempProductArray.availableStock > 0">
                                        <span class="input-group-btn" id="Quantity_decrease_{{tempProductArray.tempShopID}}">
                                            <button type="button" @click="divFunctionDecrease(tempProductArray.tempShopID,tempProductArray.id,tempProductArray)"
                                                    class="qtyminus" data-type="minus" data-field="">
                                                <span class="q_minus">&minus;</span>
                                            </button>
                                        </span>
                                        <input type="text" id="quantity_{{tempProductArray.tempShopID}}" name="quantity" class="form-control input-number" v-model="tempProductArray.quantity" min="1" max="100">
                                        <span class="input-group-btn" id="Quantity_increase_{{tempProductArray.tempShopID}}">
                                            <button type="button" @click="divFunction(tempProductArray.tempShopID,tempProductArray.id,tempProductArray)" class="qtyplus" data-type="plus" data-field="">
                                                <span class="qtyplus">&plus;</span>
                                            </button>
                                        </span>
                                    </p>
                                </div>
                                <!--<button class="qtyminus" aria-hidden="true">&minus;</button>-->
                                <!--<input type="number" name="qty" id="qty" min="1" max="10" step="1" value="1">-->
                                <!--<button class="qtyplus" aria-hidden="true">&plus;</button>-->
                                
                                <div class="product_detail_cart_buton" v-if="showHideAddToCartDiv">
                                    <button type="button" class="btn btn-black btn-small radius-5" v-if="tempProductArray.availableStock > 0" @click="Path(tempProductArray.id,tempProductArray.isShip,tempProductArray.localDelCharges)">Add to cart</button>

                                    <button v-else class="btn btn-primary btn-sm d-block" disabled>
                                        <i class="ci-cart fs-sm me-1"></i>Out Of Stock
                                    </button>
                                    <button type="button" class="btn btn-black btn-small radius-5 btn-buy-now" v-if="tempProductArray.availableStock > 0" @click="Path(tempProductArray.id,tempProductArray.isShip,tempProductArray.localDelCharges)">Buy Now</button>

                                </div>
                                <div v-else>
                                    <button type="button" class="btn btn-black btn-small radius-5">Already Added to cart</button>
                                </div>

                            </div>


                            <div class="card mt-3" v-if="tempProductArray.availableStock > 0">
                                <div class="card-header">
                                    <h3 class="mb-0">Subscription</h3>
                                </div>
                                <div class="card-body">

                                    <div id="add-subscription-type-dropdown" class=" justify-content-between subscriptionType">
                                        <!--<label class="position-relative pl-4">

            <input class="form-check-input container-check" @change="changeSubscription();" type="checkbox" v-model="checkout.Subscription">

            </label>-->
                                        <Dropdown v-model="checkout.subscriptiontype"
                                                  :options="subscriptiontypeList"
                                                  name="subscriptiontype"
                                                  filter
                                                  showClear
                                                  optionValue="value"
                                                  optionLabel="text"
                                                  placeholder="Select Subscription Type"
                                                  @change="Subscriptiontype(checkout.subscriptiontype)"
                                                  class="w-full md:w-14rem border select_subscriptiontypeList" />

                                        <div class="subscriptionPriceBox newsubscriptionPriceBox">
                                            <label v-if="tempProductArray.subscriptionPrice !='' && tempProductArray.subscriptionPrice !=null">Subscription Price: <span>${{tempProductArray.subscriptionPrice}}</span></label>
                                            <label v-else>Subscription Price: <span>${{productSalesPrice}}</span></label>
                                            <button class="btn btn-black btn-small radius-5 width-auto" type="button" @click="AddSubscribe(tempProductArray.id)">Subscribe</button>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="weeklybx" v-if="checkout.subscriptiontype=='1'">
                                            <div class="weeklybx-list" v-for="subscription in subscriptionTypeWeekly" :key="subscription.value">
                                                <input type="radio" :id="'subscription_' + subscription.value" :value="subscription.value" v-model="checkout.Weeklysubscription">
                                                <label :for="'subscription_' + subscription.value">{{ subscription.text }}</label>
                                            </div>
                                        </div>

                                        <div class="monthlybx" v-if="checkout.subscriptiontype=='2'">
                                            <div class="monthlybx-list" v-for="subscriptionMonthly in subscriptionTypemonthly" :key="subscriptionMonthly.value">
                                                <input type="radio" :id="'subscriptionMonthly_' + subscriptionMonthly.value" :value="subscriptionMonthly.value" v-model="checkout.Monthlysubscription">
                                                <label :for="'subscriptionMonthly_' + subscriptionMonthly.value">{{ subscriptionMonthly.text }}</label>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                        </form>

                        <!--<div class="shippinglist mt-4 d-flex align-items-center">
                    <ul class="list-inline mb-0">
                        <li>
                            <i class="fa-solid fa-truck"></i> Free worldwide shipping on all orders over $300
                        </li>
                        <li>
                            <i class="fa-solid fa-calendar-days"></i> Delivers in 3-7 working days <a href="#">Shipping & Return</a>
                        </li>

                    </ul>
                </div>-->

                        <hr>

                        <div class="otherinfo mt-4 d-flex align-items-center">
                            <ul class="list-inline mb-0">
                                <li>
                                    <span>SKU: </span> {{tempProductArray.sku}}
                                </li>
                                <li>
                                    <span>Categories: </span> {{tempProductArray.categoryName}}
                                </li>
                                <!--<li>
                            <span>Tags:</span> Hot, Trend
                        </li>-->
                                <li>
                                    <span>Share:</span>
                                    <!--<div v-if="socialmedialinkList!=null && socialmedialinkList.length>0">
                                <div v-for="item in socialmedialinkList">
                                    <a :href="[item.Url]" target="_blank"><i :class="[item.IconUsed.replace('fab', 'fa-brands')]"></i></a>
                                </div>

                            </div>-->
                                    <a href="javascript:;" @click="Copylink"><i class="fa fa-copy mr-1"></i></a>
                                    <a href="javascript:;" @click="ShareLink('WhatsApp')"><i class="fab fa-whatsapp mr-1"></i></a>
                                    <a href="javascript:;" @click="ShareLink('Facebook')"><i class="fa-brands fa-facebook"></i></a>
                                    <a href="javascript:;" @click="ShareLink('Twitter')"><i class="fab fa-twitter"></i></a>
                                    <a href="javascript:;" @click="ShareLink('LinkedIn')"><i class="fab fa-linkedin"></i></a>
                                    <a href="javascript:;" @click="ShareLink('Email')"><i class="fa fa-envelope"></i></a>
                                    <a href="javascript:;" @click="ShareLink('Pinterest')"><i class="fab  fa-pinterest"></i></a>
                                    <!--<a href="#"><i class="fa-brands fa-instagram"></i></a>
                            <a href="#"><i class="fa-brands fa-facebook"></i></a>
                            <a href="#"><i class="fa-brands fa-youtube"></i></a>-->
                                </li>
                            </ul>
                        </div>

                    </div>
                </div>
            </div>

            <div class="product-info">
                <div class="row">
                    <div class="col-lg-12">

                        <nav class="product-info-tabs wc-tabs mt-5 mb-5">
                            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                                <button class="nav-link active" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true">Description</button>
                                <button class="nav-link" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">Additional Information</button>
                                <button class="nav-link" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-contact" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">Reviews ({{reviewDetailsArrayLength}})</button>
                            </div>
                        </nav>
                        <div class="tab-content" id="nav-tabContent">
                            <div class="tab-pane fade active show" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                                <!--<p>Designed to fit under popular trail saddles, featuring a shock absorbing contoured pad shape and a durable easy to clean Herculon fabric top.</p>-->

                                <ul class="">
                                    <p v-html="tempProductArray.productDescription"></p>
                                </ul>

                            </div>
                            <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">

                                <ul class="list-unstyled info-desc">
                                    <li class="d-flex" style="padding-bottom: 7px" v-if="tempProductArray.weight != null">
                                        <strong>Weight </strong>
                                        <span>: {{tempProductArray.weight}} Pounds </span>

                                    </li>
                                    <li class="d-flex" style="padding-bottom: 7px" v-if="tempProductArray.length != null">
                                        <strong>Dimensions </strong>
                                        <span>: {{tempProductArray.length}} x {{tempProductArray.width}} x {{tempProductArray.height}} Inches</span>
                                    </li>
                                    <!--<li class="d-flex" style="padding-bottom: 7px">
                                <strong>Materials</strong>
                                <span>: 60% cotton, 40% polyester</span>
                            </li>
                            <li class="d-flex" style="padding-bottom: 7px">
                                <strong>Color </strong>
                                <span>: Blue, Gray, Green, Red, Yellow</span>
                            </li>
                            <li class="d-flex" style="padding-bottom: 7px">
                                <strong>Size</strong>
                                <span>: L, M, S, XL, XXL</span>
                            </li>-->
                                </ul>
                            </div>
                            <div class="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
                                <div class="row">
                                    <!--<div class="media review-block mb-4">
                                <img src="../../assets/images/user1.jpg" alt="reviewimg" class="img-fluid mr-4">
                                <div class="media-body">
                                    <div class="product-review">
                                        <span><i class="fa fa-star"></i></span>
                                        <span><i class="fa fa-star"></i></span>
                                        <span><i class="fa fa-star"></i></span>
                                        <span><i class="fa fa-star"></i></span>
                                        <span><i class="fa fa-star"></i></span>
                                    </div>
                                    <h6>David Smith <span class="text-sm text-muted font-weight-normal ml-3">-Oct 15, 2023</span></h6>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ipsum suscipit consequuntur in, perspiciatis laudantium ipsa fugit. Iure esse saepe error dolore quod.</p>
                                </div>
                            </div>-->
                                    <!--<div class="media review-block">
                                <img src="../../assets/images/user2.jpg" alt="reviewimg" class="img-fluid mr-4">
                                <div class="media-body">
                                    <div class="product-review">
                                        <span><i class="fa fa-star"></i></span>
                                        <span><i class="fa fa-star"></i></span>
                                        <span><i class="fa fa-star"></i></span>
                                        <span><i class="fa fa-star"></i></span>
                                        <span><i class="fa fa-star"></i></span>
                                    </div>
                                    <h6>Kevin Peterson <span class="text-sm text-muted font-weight-normal ml-3">-Aug 23, 2023</span></h6>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ipsum suscipit consequuntur in, perspiciatis laudantium ipsa fugit. Iure esse saepe error dolore quod.</p>
                                </div>
                            </div>-->
                                    <div class="col-lg-7" v-for="item in ReviewDetails">
                                        <div class="media review-block">
                                            <img src="../../assets/images/user2.jpg" alt="reviewimg" class="img-fluid mr-4">
                                            <div class="media-body">
                                                <div class="product-review">
                                                    <span><i class="fa fa-star"></i></span>
                                                    <span><i class="fa fa-star"></i></span>
                                                    <span><i class="fa fa-star"></i></span>
                                                    <span><i class="fa fa-star"></i></span>
                                                    <span><i class="fa fa-star"></i></span>
                                                </div>
                                                <h6>{{item.UserName}} <span class="text-sm text-muted font-weight-normal ml-3">   -     {{$filters.dateFormat(item.CreatedOn,"MM-DD-yyyy")}}</span></h6>
                                                <p>{{item.Review}}</p>
                                            </div>
                                        </div>
                                    </div>



                                    <div class="col-lg-5">
                                        <div class="review-comment mt-5 mt-lg-0" v-if="CustomerLoginUserIds != '00000000-0000-0000-0000-000000000000'">
                                            <h4 class="mb-3">Add a Review</h4>
                                            <Form autocomplete="off" @submit="onSubmitAddReview()" ref="form" :validation-schema="schema" v-slot="{ errors }">

                                                <!--<div class="starrr"><i class="tf-ion-android-star-outline"></i><i class="tf-ion-android-star-outline"></i><i class="tf-ion-android-star-outline"></i><i class="tf-ion-android-star-outline"></i><i class="tf-ion-android-star-outline"></i></div>-->
                                                <div class="form-group mb-3">
                                                    <label class="form-label">First Name<span class="req">*</span></label>
                                                    <Field type="text" class="form-control" v-model="Addreview.firstName" name="firstName" placeholder="Enter First Name"
                                                           :class="{ 'is-invalid': errors.firstName }" />
                                                    <div class="invalid-feedback">{{errors.firstName}}</div>
                                                </div>

                                                <div class="form-group mb-3">
                                                    <label class="form-label">Email<span class="req">*</span></label>
                                                    <Field type="email" class="form-control" name="email" v-model="Addreview.email" placeholder="Enter Email"
                                                           :class="{ 'is-invalid': errors.email }" />
                                                    <div class="invalid-feedback">{{errors.email}}</div>
                                                </div>
                                                <div class="form-group mb-3">
                                                    <label class="form-label">Subject <span class="req">*</span></label>
                                                    <Field type="text" class="form-control" v-model="Addreview.Subject" name="Subject" placeholder="Enter Subject"
                                                           :class="{ 'is-invalid': errors.Subject }" />
                                                    <div class="invalid-feedback">{{errors.Subject}}</div>
                                                </div>
                                                <div class="form-group mb-3">
                                                    <textarea name="comment" id="Description" v-model="Addreview.Description" class="form-control" cols="30" rows="4" placeholder="Your Review"></textarea>
                                                </div>

                                                <button type="submit" class="btn btn-primary btn-small">Submit Review</button>
                                            </Form>
                                            <!--<form action="#">
                                        <div class="starrr"><i class="tf-ion-android-star-outline"></i><i class="tf-ion-android-star-outline"></i><i class="tf-ion-android-star-outline"></i><i class="tf-ion-android-star-outline"></i><i class="tf-ion-android-star-outline"></i></div>
                                        <div class="form-group mb-3">
                                            <input type="text" class="form-control" placeholder="Your Name">
                                        </div>
                                        <div class="form-group mb-3">
                                            <input type="email" class="form-control" placeholder="Your Email">
                                        </div>
                                        <div class="form-group mb-3">
                                            <textarea name="comment" id="comment" class="form-control" cols="30" rows="4" placeholder="Your Review"></textarea>
                                        </div>

                                        <a href="#" class="btn btn-primary btn-small">Submit Review</a>
                                    </form>-->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>



                    </div>
                </div>
            </div>
        </div>
    </section>
    <!--Subscriptions Description-->

    <div v-if="DescriptionPopup" class="modal-container">
        <div class="modal-dialog modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{DescriptionPopuptitle}} </h5>

                    <a class="modal-close" @click="CloseDescriptionPopup()"><i class="fa fa-times"></i></a>
                </div>
                <div class="modal-body">

                    <div style="word-wrap: break-word;">
                        <p v-html="DescriptionPopupvalue"></p>
                        <p hidden>{{DescriptionPopupvalue}}</p>
                    </div>


                </div>
                <div class="modal-footer">
                    <button class="btn btn-secondary" @click="CloseDescriptionPopup()">Close</button>

                </div>
            </div>
        </div>
    </div>
    <Loading v-model:active="isLoading">
    </Loading>
</template>

<script>
    import Dropdown from 'primevue/dropdown';
    import UserFrontendService from '@/service/FrontendService.js'
    import ECommerce from '@/service/ECommerce.js';
    import { param } from 'jquery';
    import * as Yup from 'yup';
    import { Form, Field } from 'vee-validate';

    export default {
        name: 'ProductDetails',

        updated() {
            //window.scrollTo(0, 0);
        },
        components: {
            Form,
            Field,
            Dropdown
        },
        data() {

            const FromSchemaObject = {
                firstName: Yup.string().required('First Name is required'),
                Subject: Yup.string().required('Subject is required'),
                email: Yup.string().email('Email is invalid').matches('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$', 'Email is invalid').required('Email Address is required'),
            }
            const schema = Yup.object().shape(FromSchemaObject);

            const searchModel = {
                searchItem: null,
                status: -1,
                sortColumn: 'CreatedOn',
                sortDir: 'desc',
                pageIndex: 0,
                pageSize: 10,
                userId: localStorage.getItem("userId"),
                companyId: localStorage.getItem("SupcompanyId")
            }
            return {
                checkout: {
                    ProductId: '',
                    Weeklysubscription: [],
                    Monthlysubscription: [],
                    Dailysubscription: null,
                    Quarterlysubscription: null,
                    Annualysubscription: null,
                    subscriptiontype: null,
                    Subscription: false,
                    subscriptionPrice: null,
                    IsSubscribe: false,
                },

                subscriptionTypeWeekly: [
                    { value: 'Sunday', text: 'Sunday' },
                    { value: 'Monday', text: 'Monday' },
                    { value: 'Tuesday', text: 'Tuesday' },
                    { value: 'Wednesday', text: 'Wednesday' },
                    { value: 'Thursday', text: 'Thursday' },
                    { value: 'Friday', text: 'Friday' },
                    { value: 'Saturday', text: 'Saturday' }
                ],
                subscriptiontypeList: [
                    { value: '0', text: 'Daily' },
                    { value: '1', text: 'Weekly' },
                    { value: '2', text: 'Monthly' },
                    /*{ value: '3', text: 'Quarterly' },*/
                    { value: '4', text: 'Annually' }
                ],
                subscriptionTypemonthly: [],
                DescriptionPopup: false,
                DescriptionPopuptitle: '',
                DescriptionPopupvalue: '',
                ProductcategoryId: null,
                isProductDetails: false,
                isLoading: false,
                productdetails: [],
                customerLoginId: null,
                currentCartId: null,
                quantity: null,
                tempProductArray: [],
                productSalesPrice: null,
                productPrice: null,
                schema,
                CustomerLoginUserIds: localStorage.getItem("userId"),
                showHideQuantityDiv: false,
                showHideAddToCartDiv: true,
                searchModel,
                socialmedialinkList: [],
                description: [],
                limitedDescription: '',
                ReviewDetails: [],
                reviewDetailsArrayLength:null,
                pageIndex: 0,
                pageSize: 10,
                Addreview: {
                    firstName: '',
                    username: '',
                    email: '',
                    companyId: localStorage.getItem('companyId'),
                    Subject: '',
                    Description: ''
                },
            }
        },
        created() {
            this.ProductcategoryId = this.$route.params.Id;
            this.customerLoginId = null;
            //this.currentCartId = null;
           // localStorage.setItem("CurrentCartId", this.productId);
            localStorage.setItem("CurrentCartId", this.ProductcategoryId);
            this.getProductDetailsFrontEnd(this.ProductcategoryId, this.customerLoginId, this.currentCartId);
            this.getListOfSocialLinks();
            this.GetReviewList();
            this.subscriptionMonthlydate();
        },

        methods: {
            submitCheckOut() {
                debugger;
                this.loading = true;
                localStorage.removeItem("AddasSubscriptionProductId");
                localStorage.setItem("AddasSubscriptionProductId", this.ProductcategoryId);

                if (typeof this.checkout.Monthlysubscription == "object") {
                    if (this.checkout.Monthlysubscription.length != 0) {
                        this.checkout.Monthlysubscription = this.checkout.Monthlysubscription.toString();
                        this.checkout.Weeklysubscription = null
                    }

                }
                //if (this.checkout.Weeklysubscription != null) {
                //    this.checkout.Weeklysubscription = this.checkout.Weeklysubscription.toString();
                //    this.checkout.Monthlysubscription = null
                //}
                if (this.checkout.Weeklysubscription != null && this.checkout.Weeklysubscription != '') {
                    this.checkout.Weeklysubscription = this.checkout.Weeklysubscription.toString();
                    this.checkout.Monthlysubscription = null
                }
                if (this.checkout.subscriptiontype == '0') {
                    this.checkout.Dailysubscription = 'daily'
                    this.checkout.Monthlysubscription = null
                    this.checkout.Weeklysubscription = null

                }
                //if (this.checkout.subscriptiontype == '3') {
                //    this.checkout.Quarterlysubscription = 'Quarterly'
                //    this.checkout.Monthlysubscription = null
                //    this.checkout.Weeklysubscription = null

                //}
                if (this.checkout.subscriptiontype == '4') {
                    this.checkout.Annualysubscription = 'Annually'
                    this.checkout.Monthlysubscription = null
                    this.checkout.Weeklysubscription = null

                }
                //this.checkout.subscriptionPrice = this.tempProductArray.subscriptionPrice;

                //localStorage.setItem("subscriptionPrice", this.tempProductArray.subscriptionPrice);
            },

            changeSubscription() {
                if (this.checkout.Subscription == false) {
                    this.checkout.Monthlysubscription = [];
                    this.checkout.Weeklysubscription = [];
                    this.checkout.Dailysubscription = null;
                    this.checkout.Quarterlysubscription = null;
                    this.checkout.Annualysubscription = null;
                }
            },
            Subscriptiontype(value) {
                if (value == '0') {
                    this.checkout.Monthlysubscription = [];
                    this.checkout.Weeklysubscription = [];
                }
                if (value == '1') {
                    this.checkout.Dailysubscription = null;
                    //this.checkout.Quarterlysubscription = null;
                    this.checkout.Annualysubscription = null;
                    this.checkout.Monthlysubscription = [];

                }
                if (value == '2') {
                    this.checkout.Dailysubscription = null;
                    //this.checkout.Quarterlysubscription = null;
                    this.checkout.Annualysubscription = null;
                    this.checkout.Weeklysubscription = [];

                }
                if (value == '3') {
                    this.checkout.Monthlysubscription = [];
                    this.checkout.Weeklysubscription = [];
                }
                if (value == '4') {
                    this.checkout.Monthlysubscription = [];
                    this.checkout.Weeklysubscription = [];
                }
            },
            subscriptionMonthlydate() {
                for (let i = 1; i <= 31; i++) {
                    this.subscriptionTypemonthly.push({ value: i, text: i.toString() });
                }
            },


            AddSubscribe(Id) {
                debugger;
                if (localStorage.getItem('userlogin') != "false") {

                    let subscriptionInfo = localStorage.getItem("SubscriptionDetails");
                    var subscriptiondata = JSON.parse(subscriptionInfo);
                    if (subscriptiondata != null) {
                        if (subscriptiondata.subscriptiontype != null || subscriptiondata.subscriptiontype != 'undefined') {
                            this.error("You cannot add more than one product in subscription!");
                            return false;
                        }
                    }

                    if (this.checkout.subscriptiontype == null) {
                        this.error(`Select Subscription Type.`);
                        return false;
                    }
                    if (this.checkout.subscriptiontype != null) {
                        if (this.checkout.subscriptiontype == "1") {
                            if (this.checkout.Weeklysubscription.length == 0) {
                                this.error(`Select Days.`); 
                                return false;
                            }

                        }
                        if (this.checkout.subscriptiontype == "2") {
                            if (this.checkout.Monthlysubscription.length == 0) {
                                this.error(`Select Date.`);
                                return false;
                            }
                        }
                    }
                    this.submitCheckOut();
                    debugger;
                    if (this.tempProductArray.subscriptionPrice == null || this.tempProductArray.subscriptionPrice == '') {
                        this.checkout.subscriptionPrice = this.tempProductArray.salePrice;
                    }
                    else {
                        this.checkout.subscriptionPrice = this.tempProductArray.subscriptionPrice;
                        this.checkout.IsSubscribe = true;
                    }
                    if (this.tempProductArray.isShip == false) {
                        localStorage.setItem('IsShip', this.tempProductArray.isShip)
                        localStorage.setItem('SelectedProductId', this.tempProductArray.id);
                    }
                    localStorage.removeItem("SubscriptionDetails");
                    localStorage.setItem("SubscriptionDetails", JSON.stringify(this.checkout));
                }

                if (localStorage.getItem('userlogin') == "false") {
                    this.$router.push({ path: `/Login` })
                }
                else {
                    localStorage.setItem('cartaction', 'cartcalc');
                    this.$router.push({ path: `/Cart/${Id}` })
                }
                if (this.CustomerLoginUserIds == null) {
                    this.showHideQuantity = false;
                }
                else {
                    this.showHideQuantity = true;
                }


            },

            onSubmitAddReview() {
                debugger;
                    this.isLoading = true;
                    var userModel = {
                        aspnetId: localStorage.getItem('userId'),
                        email: this.Addreview.email,
                        assetName: this.Addreview.firstName,
                        Subject: this.Addreview.Subject,
                        review: this.Addreview.Description,
                        companyId: localStorage.getItem('companyId'),
                        assetId: this.ProductcategoryId
                    }

                    ECommerce.AddUpdatemarkectReview(userModel).then(response => {
                        if (response.status == 200) {
                            setTimeout(() => {
                                this.isLoading = false;
                                this.success("Feedback has been succsesfully submitted");
                                this.FromSchemaObject
                                this.$refs.form.resetForm();
                                this.GetReviewList();
                            }, 100);
                            this.Addreview.email = '',
                                this.Addreview.firstName = '',
                                this.Addreview.Description = '',
                                this.Addreview.Subject = ''
                        }
                        this.isLoading = false;
                    }).catch(error => { this.error(`Something Went Wrong.`); this.isLoading = false; })
              
                

            },
            GetReviewList() {
                debugger
                this.isLoading = true;
                if (this.CustomerLoginUserIds == null) {
                    this.CustomerLoginUserIds = "00000000-0000-0000-0000-000000000000"
                }
                ECommerce.GetReviewsListing(this.CustomerLoginUserIds, localStorage.getItem('companyId'), 'home', this.pageIndex, this.pageSize, this.ProductcategoryId).then((response) => {
                    debugger
                    this.ReviewDetails = response.data;
                    this.reviewDetailsArrayLength = this.ReviewDetails.length;
                    this.isLoading = false;
                    console.log('rtty', response.data)
                })
            },
            getListOfSocialLinks() {
                this.isLoding = true;
                UserFrontendService.GetSocialLinkList(this.searchModel.searchItem, this.searchModel.sortColumn, this.searchModel.sortDir, this.searchModel.pageIndex, this.searchModel.pageSize, '00000000-0000-0000-0000-000000000000', '00000000-0000-0000-0000-000000000000', 1).then(response => {
                    console.log('response socialmedialinkList', response);
                    this.socialmedialinkList = response.data.data;
                })
                setTimeout(() => { this.isLoding = false; }, 1000);

            },

            UpdateQuantity(cartId, itemId, qty) {
                //debugger;
                ECommerce.UpdateQuantity(cartId, itemId, qty, localStorage.getItem("CurrentCartId"), this.CustomerLoginUserIds).then((response) => {
                    this.isLoading = false;
                    this.RefreshCartItems(cartId, itemId);
                })
            },
            RefreshCartItems(cartId, itemId) {
               // debugger;
                this.isLoading = true;
                ECommerce.RefreshCartItems(cartId, itemId, localStorage.getItem("CurrentCartId"), this.CustomerLoginUserIds).then((response) => {
                    //this.tempProductArray = response.data._CartsModel;

                    this.isLoading = false;

                })
                //this.isLoading = false;
            },

            divFunctionDecrease(TempShopID, productId, tempProductArray) {
                var id = '#quantity_' + TempShopID;
                let qty = tempProductArray.quantity;
                if (parseInt(qty) < 2) {
                    return false;
                }
                else {
                    var insss = (parseInt(qty) - 1);
                    tempProductArray.quantity = insss;

                    this.UpdateQuantity(TempShopID, productId, insss);

                }
            },
            divFunction(TempShopID, productId, tempProductArray) {
               // debugger;
                var id = '#quantity_' + TempShopID;
                var qty = tempProductArray.quantity;
                var insss = (parseInt(qty) + 1);
                tempProductArray.quantity = insss;
                var aviablestock = tempProductArray.availableStock;
                if (aviablestock == 0) {
                    window.location.href = "FrontEndShop/Shop/" + productId;
                }
                if (insss > aviablestock) {

                    alert("You can not order more than available quantity. Available quantity is: " + aviablestock);
                    tempProductArray.quantity = aviablestock;
                    this.isLoading = false;
                    return false;
                }
                else {

                    this.UpdateQuantity(TempShopID, productId, insss);
                }

                if (qty < 0) {
                    this.toaster.error("Please enter valid quantity");
                    this.isLoading = false;
                    return false;
                }
            },

            getProductDetailsFrontEnd() {
                this.isLoading = true;
               // debugger;
                ECommerce.GetProductDetailsFrontEndShop(this.ProductcategoryId, this.CustomerLoginUserIds, this.currentCartId).then((response) => {
                    debugger;
                    this.productdetails = response.data.productIteam;
                    this.tempProductArray = this.productdetails[0];
                    this.productSalesPrice = this.tempProductArray.salePrice.toFixed(2);
                   // this.limitedDescription = this.$filters.TruncateStr(this.tempProductArray.productDescription, 150);
                  //  this.description = Array.from(this.tempProductArray.productDescription)
                    this.productPrice = this.tempProductArray.price.toFixed(2);
                    if (this.CustomerLoginUserIds == null) {
                        this.showHideQuantityDiv = false;
                    }
                    else {
                        if (this.tempProductArray.quantity > 0) {
                            if (localStorage.getItem('userId') != null) {
                                this.showHideAddToCartDiv = false;
                            }
                            this.showHideQuantityDiv = true
                        }
                    }
                    this.isLoading = false;
                })
            },
            Path(Id, isShip, localDelCharges)
            {
                this.isLoading = true;
                // debugger;
                if (localStorage.getItem('userId') == null || localStorage.getItem('userId') == '') { 
                    this.$router.push({ path: `/Login` });

                }
                 else
                    {
                    let subscriptionInfo = localStorage.getItem("SubscriptionDetails");
                    var subscriptiondata = JSON.parse(subscriptionInfo);
                    if (subscriptiondata != null) {
                        if (subscriptiondata.subscriptiontype != null || subscriptiondata.subscriptiontype != 'undefined') {
                            this.error("You cannot add more than one product in subscription!");
                            this.isLoading = false;
                            return false;
                            
                        }
                    }
                    if (isShip == false) {
                        localStorage.setItem('IsShip', isShip)
                        localStorage.setItem('SelectedProductId', Id);
                        localStorage.setItem('localDelCharges', localDelCharges);
                    }
                    localStorage.setItem('cartaction', 'dontcalc');
                    localStorage.removeItem('currentProductId');
                    localStorage.setItem('currentProductId', Id);
                this.$router.push({ path: `/Cart/${Id}` })
                this.showHideQuantityDiv = true

                }
                this.changeSubscription();
                localStorage.removeItem("SubscriptionDetails");
            },
            redirecttohomepage() {
                this.$router.push({ path: `/Home` });
            },
            redirecttoProductList() {
                this.$router.push({ path: `/ProductList` });
            },
            ///shareLink
            Copylink() {
                this.url = window.location.host + `/ProductDetail/` + `${this.ProductcategoryId}`;
                if (!(this.url.substring(0, this.url.lastIndexOf('/') + 1) == 'http://'))
                    this.url = 'https://' + this.url;
                window.navigator['clipboard'].writeText(this.url);
                this.success("Link copied.");
            },
            ShareLink(SocialMediaType) {
                this.url = window.location.host + `/ProductDetail/` + `${this.ProductcategoryId}`;
                var subject = 'send Social Link';

                if (SocialMediaType == "WhatsApp") {
                    var link = document.createElement('a');
                    link.href = 'https://api.whatsapp.com/send' +
                        this.$Helpers.objectToGetParams({
                            text: this.url
                        }),
                        link.target = '_blank';
                    link.textContent = 'Open in New Window';
                    link.click();
                }
                else if (SocialMediaType == "Facebook") {
                    var link = document.createElement('a');
                    link.href = 'https://www.facebook.com/sharer/sharer.php' +
                        this.$Helpers.objectToGetParams({
                            u: this.url
                        }),
                        link.target = '_blank';
                    link.textContent = 'Open in New Window';
                    link.click();

                }
                else if (SocialMediaType == "Twitter") {
                    var link = document.createElement('a');
                    link.href = 'https://www.twitter.com/share' +
                        this.$Helpers.objectToGetParams({
                            url: this.url,
                        }),
                        link.target = '_blank';
                    link.textContent = 'Open in New Window';
                    link.click();
                }
                else if (SocialMediaType == "LinkedIn") {
                    var link = document.createElement('a');
                    link.href = 'https://linkedin.com/shareArticle' +
                        this.$Helpers.objectToGetParams({
                            mini: true,
                            url: this.url
                        }),
                        link.target = '_blank';
                    link.textContent = 'Open in New Window';
                    link.click();
                }
                else if (SocialMediaType == "Email") {
                    var link = document.createElement('a');
                    link.href = 'mailto:' +
                        this.$Helpers.objectToGetParams({
                            subject,
                            body: this.url
                        }),
                        link.target = '_blank';
                    link.textContent = 'Open in New Window';
                    link.click();
                }
                else if (SocialMediaType == "Pinterest") {
                    var link = document.createElement('a');
                    link.href = 'https://www.pinterest.com/pin/create/button/' +
                        this.$Helpers.objectToGetParams({
                            url: this.url
                        }),
                        link.target = '_blank';
                    link.textContent = 'Open in New Window';
                    link.click();
                }
            },
            OpenDescriptionModel(ProductDetail) {
                debugger
                this.DescriptionPopup = true;
                this.DescriptionPopupvalue = ProductDetail.productDescription;
                this.DescriptionPopuptitle = ProductDetail.productName;
            },
            CloseDescriptionPopup() {
                this.DescriptionPopup = false;
            },

        }
    }



</script>